import { type IconProps } from '@ubnt/icons';
import AddWithCircleIcon from '@ubnt/icons/AddWithCircleIcon';
import { RadioRolesEnum } from '@ubnt/link-core/enums';
import { useDevicePanel } from '@ubnt/link-core-ui/components/BottomPanel/context/DevicePanelContext';
import { type KeyboardEvent, useCallback } from 'react';

import Tooltip from '@ubnt/link-core-ui/components/Tooltip';
import { useDispatch, useSelector } from 'app/store';
import { devicesCustomClientFormOpenChange, devicesDeviceRoleSelector } from 'modules/devices/slice';
import { useApplicationStore } from 'modules/application/store';
import { trackEvent } from 'utils/googleAnalytics';

const AddClientButton = (props: IconProps) => {
  const { id } = useDevicePanel();
  const { className, ...rest } = props;

  const role = useSelector((state) => id && devicesDeviceRoleSelector(state, id));

  const dispatch = useDispatch();
  const isMobile = useApplicationStore((state) => state.isMobile);

  const onClick = useCallback(() => {
    dispatch(devicesCustomClientFormOpenChange(true));
    trackEvent('clientFormAction', { action: 'addButton' });
  }, [dispatch]);

  const onKeyDown = useCallback(
    (event: KeyboardEvent<SVGSVGElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    },
    [onClick]
  );

  if (role !== RadioRolesEnum.Cpe) {
    return null;
  }

  return (
    <Tooltip description="Add a custom client device" disableHover={isMobile} className={className}>
      <AddWithCircleIcon
        aria-label="Add a custom client device"
        data-testid="add-custom-client"
        onClick={onClick}
        onKeyDown={onKeyDown}
        role="button"
        tabIndex={0}
        {...rest}
      />
    </Tooltip>
  );
};

export default AddClientButton;
